import {Router} from "@angular/router"
import {IrwinSearchService} from "./incident/irwin/irwin-search.service"
import {Injectable} from "@angular/core"
@Injectable({
	providedIn: "root",
})
/**
 * @description this service exists to build route links to pages in the case dashboard feature area.
 * Two reasons for this
 * 1.) It would be convenient to do them all in one spot. If we did so, a change to our routes would be completely painless.
 * 2.) As part of a map performance project, case dashboard links may get waaaay more complicated. It will be easier to call a function.
 * The date of creation is 3.30.26, and if there are very few implementations in a year or so, maybe just scrap this service.
 * */
export class RouterLinkBuilderService {
	constructor(private router: Router) {}
	/**
	 * @param irwinId of the case you wish to nav to
	 * @returns Absolute link to the incident info page.*/
	public getIncidentInfoLink(irwinId: string): string {
		let link = `/incidents/dashboard/${irwinId}/(sidebar-outlet:incidentInformation)`
		return link
	}
}
